import { IRevenueSpendByAccountListTableLang } from '../../../types/lang'

export const revenueSpendByAccountListTableLang: IRevenueSpendByAccountListTableLang = {
	revenue_spend_by_account_list_table: {
		column_date: 'Date_ru',
		column_account: 'Account_ru',
		column_team: 'Team_ru',
		column_kt_group: 'KT Group_ru',
		column_revenue_cpa: 'Revenue Cpa_ru',
		column_revenue_offer_spend: 'Revenue Offer Spend_ru',
		column_revenue_total: 'Revenue Total_ru',
		column_spend: 'Spend_ru',
		column_roi: 'ROI, %_ru',
		column_account_fb: 'Accounts FB_ru',
		column_creo: 'Creo_ru',
		column_installs: 'Installs_ru',
		column_slices: 'Slices_ru',
		column_agency_percent: 'Agency percent_ru',
		column_profit: 'Profit_ru'
	}
}